if (!customElements.get('koko-balm-ingredients')) {
  customElements.define('koko-balm-ingredients', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const opener = this.querySelector('[data-ingredients-open]');
      const dialog = this.querySelector('dialog');
      if (!opener || !dialog) return;
      this.dialog = dialog;
      opener.addEventListener('click', () => {
        if (dialog.open) return;
        this.previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        this.scrollLocked = true;
      }, { signal });
      dialog.addEventListener('close', () => {
        this.unlockScroll();
        if (opener.isConnected) opener.focus({ preventScroll: true });
      }, { signal });
      // Only a click that starts and ends on the backdrop closes the window.
      let backdropStart = false;
      const outside = event => {
        const rect = dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      };
      dialog.addEventListener('pointerdown', event => { backdropStart = event.target === dialog && outside(event); }, { signal });
      dialog.addEventListener('click', event => {
        if (backdropStart && event.target === dialog && outside(event)) dialog.close();
        backdropStart = false;
      }, { signal });
    }
    unlockScroll() {
      if (!this.scrollLocked) return;
      document.body.style.overflow = this.previousOverflow;
      this.scrollLocked = false;
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
    }
  });
}
